import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './LoadingScreen';

export function RequireAuth() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}

export function RequireAdmin() {
  const { isAdmin, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return isAdmin ? <Outlet /> : <Navigate to="/login" replace />;
}

export function RequireClient() {
  const { isClient, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return isClient ? <Outlet /> : <Navigate to="/login" replace />;
}

export function RequireGuest() {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (isAuthenticated) {
    return <Navigate to={isAdmin ? '/admin' : '/client'} replace />;
  }
  return <Outlet />;
}
